/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Slider from 'react-slick';
import './productdetail.scss';
import Header from './header';

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow next-arrow`}
      style={{ ...style }}
      onClick={onClick}
    >
      &#10095;
    </div>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow prev-arrow`}
      style={{ ...style }}
      onClick={onClick}
    >
      &#10094;
    </div>
  );
}

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/products/${id}`);
        console.log('Product details:', response.data); // Log the API response
        const productData = response.data;
        // Correctly parse the productImages array
        if (productData.productImages.$values) {
          productData.productImages = productData.productImages.$values;
        } else {
          productData.productImages = [];
        }
        setProduct(productData);
      } catch (error) {
        setError('Error fetching product details.');
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!product) return <div>Product not found.</div>;

  const sliderSettings = {
    dots: false, // Disable numbered pagination
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <NextArrow />, // Custom right arrow
    prevArrow: <PrevArrow /> // Custom left arrow
  };

  const renderSlides = () => {
    const slides = [
      <div key="main-image" className="slide">
       <img src={`${import.meta.env.VITE_API_URL1}${product.mainImagePath}`} alt={product.name} className="main-image" />
     
       </div>
    ];

    if (product.productImages.length > 0) {
      product.productImages.forEach((image, index) => {
        slides.push(
          <div key={`additional-image-${index}`} className="slide">
            <img 
              src={`${import.meta.env.VITE_API_URL1}${image.imagePath}`}
              alt={`Additional image ${index}`} 
              className="additional-image" 
              onError={(e) => { 
                e.target.onerror = null; 
                
              }}
            />
          </div>
        );
      });
    }

    return slides;
  };

  return (
    <div>
      <Header />
      <div className="product-detail">
        <h2>{product.name}</h2>
        <Slider {...sliderSettings}>
          {renderSlides()}
        </Slider>
        <div className="opistext">
         
        <p>Opis:</p> <div className="product-description">{product.description}</div>
        <p> Cena: {product.price}
        {/\d/.test(product.price) && ' RSD'}</p>
          <button onClick={() => navigate(-1)} className="back-button">Nazad</button>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
